/**
 * MDB Collapse — אתחול אקורדיון שאלות ותשובות (אחרי mdb.min.js).
 * https://mdbootstrap.com/docs/standard/components/accordion/
 */
(function () {
  "use strict";

  function getMdbCollapseClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Collapse === "function") {
      return m.Collapse;
    }
    var d = m.default;
    if (d && typeof d.Collapse === "function") {
      return d.Collapse;
    }
    return null;
  }

  function initBusinessFaqAccordion() {
    var CollapseClass = getMdbCollapseClass();
    if (!CollapseClass) {
      return;
    }

    var root = document.querySelector(".br-faq__accordion#businessFaqAccordion");
    if (!root) {
      return;
    }

    var panels = root.querySelectorAll(".accordion-collapse");
    for (var i = 0; i < panels.length; i++) {
      var el = panels[i];
      try {
        if (typeof CollapseClass.getOrCreateInstance === "function") {
          CollapseClass.getOrCreateInstance(el);
          continue;
        }
        var existing =
          typeof CollapseClass.getInstance === "function" ? CollapseClass.getInstance(el) : null;
        if (existing) {
          continue;
        }
        new CollapseClass(el);
      } catch (err) {
        console.error("[business-sites] FAQ Collapse", err);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBusinessFaqAccordion, { once: true });
  } else {
    initBusinessFaqAccordion();
  }
})();
